/* eslint-disable @nx/enforce-module-boundaries */
import { Injectable } from '@angular/core';
import { TravelService } from '../../api/services/travel.service';
import { BehaviorSubject, of, tap } from 'rxjs';
import { Travel } from '../../common/models/Travel';

@Injectable()
export class TravelDetailsService {
  private travels: Travel[] = []
  private _selectedTravel = new BehaviorSubject<Travel | null>(null)
  private _key = 'sk.eyJ1IjoiZ2VuZHJ5cyIsImEiOiJjbHoycGZtbjAwZWZqMmtwdWcxbmMwMzRsIn0.38sMtacyMF8x9ApT5a_dSQ'
  selectedTravel$ = this._selectedTravel.asObservable()

  constructor( private travelSrv: TravelService) { }

  getTravelById(id: string){
    if(this.isTravelAlredySaved(id)){
      const travel = this.travels.find(item => item.id == id)!
      this._selectedTravel.next(travel)
      return of(travel)
    }

    return this.travelSrv.getTravelById(id)
    .pipe(
      tap(data => {
        this.travels.push(data)
        this._selectedTravel.next(data)
      })
    )
  }

  get selectedTravel(){
    return this._selectedTravel.value
  }

  set selectedTravel(travel: Travel | null){
    this._selectedTravel.next(travel)
  }

  private isTravelAlredySaved(id: string){
    if(this.travels.find(item => item.id == id)){
      return true
    }

    return false
  }

  getTravelImageUrl(travel: Travel){
    const encodedPolyline = encodeURIComponent(travel.route.polyline.encodedPolyline)
    return `https://api.mapbox.com/styles/v1/mapbox/streets-v12/static/path-7+8080ff(${encodedPolyline}),pin-s+00ff00(${travel.longitudeOrigin},${travel.latitudeOrigin}),pin-s+0080ff(${travel.longitudeDestination},${travel.latitudeDestination})/auto/1024x768?access_token=${this._key}`
  }

}
